import { common } from '@neo-one/client-common';
import BN from 'bn.js';
export const MAX_SHL_SHR = 65535;
export const MIN_SHL_SHR = -MAX_SHL_SHR;
export const MAX_SIZE_BIG_INTEGER = 32;
export const MAX_STACK_SIZE = 2 * 1024;
export const MAX_ITEM_SIZE = 1024 * 1024;
export const MAX_INVOCATION_STACK_SIZE = 1024;
export const MAX_ARRAY_SIZE = 1024;
export const MAX_ARRAY_SIZE_BN = new BN(1024);
export const BLOCK_HEIGHT_YEAR = 2000000;
export const BLOCK_HEIGHT_MAX_SIZE_CHECKS = Number.MAX_SAFE_INTEGER;
const ratio = 100000;
export const FEES = {
    ONE: new BN(ratio * 1),
    TEN: new BN(ratio * 10),
    TWENTY: new BN(ratio * 20),
    ONE_HUNDRED: new BN(ratio * 100),
    TWO_HUNDRED: new BN(ratio * 200),
    FOUR_HUNDRED: new BN(ratio * 400),
    FIVE_HUNDRED: new BN(ratio * 500),
    ONE_THOUSAND: new BN(ratio * 1000),
};
export const FREE_GAS = common.TEN_FIXED8;

//# sourceMappingURL=constants.js.map
